import FilterDateLast12Months from "./FilterDateLast12Months";
const FilterVoidedDate = (props: any) => {
  const before = props?.before;

  return (
    <FilterDateLast12Months
      source="limitVoidedDate"
      label="Voided Date"
      variant="outlined"
      {...props}
    />
  );
};

export default FilterVoidedDate;
